import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SquareContainer from './SquareContainer.jsx';
import { useNavigate } from 'react-router-dom';
import { getLink } from "../../dataProvider/links.js";
import { connect } from "react-redux"
import { forgotPassswordUser } from '../../actions/user.js'
import { Helmet } from "react-helmet";
import {error as logError} from '../../logger.js'

import emailIconV2 from "../../img/v2/contact/email.png"

import "../../scss/v2/user/forgotPassword.scss"

function ForgotPassword(props) {

    const { t, i18n } = useTranslation();
    const [email, setEmail] = useState('');
    let navigate = useNavigate();

    const handleSubmit = () => {
        props.dispatch(forgotPassswordUser(email, i18n.language))
        .then(() => {
            navigate(getLink("passwordSent", i18n.language))
        })
        .catch(error => {
            if(!error.statusCode) logError(error);
        })
    }

    return (
        <SquareContainer>
            <Helmet>
                <title>{t("meta.title.forgotPassword")}</title>
                <meta name="description" content={t("meta.description.forgotPassword")} />
            </Helmet>
            <div className="forgotPassword">
                <div className="row">
                    <div className="col-12 col-lg-6 offset-lg-3">
                        <h1 className="user-square-container-title">{t('forgotPassword.title')}</h1>
                        <h2 className="user-square-container-subtitle">{t('forgotPassword.subtitle')}</h2>
                        <div className="user-square-container-input-group">
                            <p className="user-square-container-input-group-label">{t('forgotPassword.label.email')}</p>
                            <input className="user-square-container-input-group-input" placeholder={t('forgotPassword.placeholder.email')} onChange={(event) => { setEmail(event.target.value) }} />
                            <div className="user-square-container-input-group-left-icon">
                                    <img className="img img-fluid user-square-container-input-group-left-icon-svg" src={emailIconV2} alt={emailIconV2} />
                            </div>
                        </div>
                        <div className="text-center">
                            <button className="button orange-button" onClick={handleSubmit}>{t('forgotPassword.submit')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </SquareContainer>
    )

}

const mapStateToProps = () => ({ });

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);